<template>
    <div class="page_card" v-on:click.prevent="onClick">
        <div class="page_card_inner_wrap">
            <a :href="model.relative_url_path" class="page_card_title">
                {{ model.title }}
            </a>
            <div class="page_card_breadcrumb">
                {{ getBreadcrumbs }}
            </div>
            <div class="card_page_summary">
                {{ model.summary }}
            </div>
        </div>
    </div>
</template>

<script>
    import cardMixin from "../../mixins/card-mixin";

    export default {
        name: "PageCard",
        mixins: [cardMixin],
        props: {
            model: {
                type: Object,
                default: {
                    title: '',
                    relative_url_path: '',
                    summary: ''
                }
            }
        },
        methods: {
            onClick: function (e) {
                this.$emit('clicked', e);
            }
        },
        computed: {
            getBreadcrumbs: function () {
                if (this.model.breadcrumb?.length) {
                    return `${this.model.breadcrumb[0]}`
                }
                return ''
            }
        }
    };
</script>
